if(!customElements.get('product-variants-wrapper')) {
    class ProductVariantsWrapper extends HTMLElement {
        constructor() {
            super();
            this.currentVariant = JSON.parse(this.querySelector('[data-js-variant-data]').textContent);
            this.optionsHasSwatchImages = [...this.querySelectorAll('.product-variant__label')].some(label => label.hasAttribute('data-has-swatch-image'));
        }

        connectedCallback() {
            this.currentVariant && this.currentVariant.options && this.updateVariantNameTitle(this.currentVariant.options[0]);
            document.addEventListener('current-variant-updated', (event) => {
                this.updateVariantNameTitle(event.detail.variant.option1);
            });
        }

        updateVariantNameTitle(value) {
			const el = this.querySelector('.product-variant__name');
			if (!el || !this.optionsHasSwatchImages) return;
			const base = el.textContent.split(':')[0].trim();
			el.textContent = `${base}: ${value}`;
		}
    }

    customElements.define('product-variants-wrapper', ProductVariantsWrapper);
}